import React, { useState } from 'react';
import FooterPageLayout from '../../components/layouts/FooterPageLayout';
import ChatbotModal from '../../components/PopUpModal/ChatbotModal';

const FAQs = () => {
  const [chatbotOpen, setChatbotOpen] = useState(false);
  
  const faqs = [
    {
      question: "What is Pebble?",
      answer: "Pebble is a marketplace platform connecting event organizers with marketplace sellers. We help you discover festivals, markets, and events while simplifying vendor applications and event management."
    },
    {
      question: "How do I get started as an Event Organizer?",
      answer: "Sign up for an Event Organizer account, complete your profile, and create your first event. Your event can be featured in our Browse Events section where thousands of vendors discover new opportunities."
    },
    {
      question: "How do I get started as a Marketplace Seller?",
      answer: "Create a Marketplace Seller account and build your business profile. Browse our Events Directory to discover markets and festivals, then apply to events that match your business."
    },
    {
      question: "What types of events are on Pebble?",
      answer: "Our platform features festivals, farmers markets, craft fairs, food festivals, art shows, pop-up markets, and community events. Browse our Events Directory to discover opportunities near you."
    },
    {
      question: "How does the vendor application process work?",
      answer: "Sellers can browse events in our directory and submit applications directly through the platform. Event organizers review applications and communicate with vendors all through Pebble."
    },
    {
      question: "What partnership opportunities are available?",
      answer: "We offer Event Organizer Partnerships (featuring your event in our newsletter and Browse Events), Vendor Partnerships (promoting exclusive deals on our marketplace), and Strategic Alliances with tourism boards, chambers of commerce, brands, venues, and community organizations."
    },
    {
      question: "Do you promote events and vendors?",
      answer: "Yes! Partners get featured in our newsletter, social media channels, and Browse Events section. We also capture professional content at events and create case studies to showcase success stories."
    },
    {
      question: "How do I become a partner?",
      answer: "Visit our Partnerships page and click 'Contact Us' or 'Apply for Partnership' to get started. We'll work with you to create a custom partnership that fits your needs."
    }
  ];

  return (
    <FooterPageLayout>
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-semibold text-grey-900 mb-8">Frequently Asked Questions</h1>
        
        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-lg p-6 shadow-sm border border-grey-200">
              <h3 className="text-lg font-medium text-grey-900 mb-2">{faq.question}</h3>
              <p className="text-grey-700 leading-relaxed">{faq.answer}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-grey-700 mb-4">Still have questions? We're here to help!</p>
          <div className="flex gap-4 justify-center">
            <button 
              onClick={() => setChatbotOpen(true)}
              className="bg-[#B22A2B] text-white px-6 py-2 rounded-lg hover:bg-[#8a2122] transition-colors"
            >
              Ask AI Assistant
            </button>
            <button 
              onClick={() => window.location.href = '/contact'}
              className="bg-grey-900 text-white px-6 py-2 rounded-lg hover:bg-grey-800 transition-colors"
            >
              Contact Support
            </button>
          </div>
        </div>
      </div>

      <ChatbotModal open={chatbotOpen} handleClose={() => setChatbotOpen(false)} />
    </FooterPageLayout>
  );
};

export default FAQs; 